import { Col, Row } from "antd";

import { apiUrl } from "../../../../providers/companyInfo";
import QuestionContent from "./QuestionContent";

export default function FormCollapseItem(props) {
	const { index, catDescription, dataQuestion, catAttachment } = props;

	return (
		<Row gutter={[20, 0]} id={`form-collapse-item-${index}`}>
			{catDescription ? (
				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					{catDescription}
				</Col>
			) : null}
			{catAttachment ? (
				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<div className="category-image">
						<img
							src={apiUrl(catAttachment.file_path)}
							alt={catAttachment.file_name}
						/>
					</div>
				</Col>
			) : null}

			{dataQuestion.map((item, index) => {
				return (
					<Col xs={24} sm={24} md={24} lg={24} xl={24} key={index}>
						<QuestionContent
							namePath={[`q_${item.id}`]}
							question={item.question}
							question_tips={item.question_tips}
							description={item.description}
							type={item.question_type}
							required={item.required ? true : false}
							max_checkbox={item.max_checkbox ? item.max_checkbox : 0}
							escape_questions={
								item.escape_questions ? item.escape_questions : []
							}
							form_question_options={
								item.form_question_options.length
									? item.form_question_options
									: []
							}
						/>
					</Col>
				);
			})}
		</Row>
	);
}
